import { ChangePasswordDialogExpComponent } from './../../changepasswordexp-dialog/changepassword.dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, ElementRef, OnInit, Renderer2, HostListener } from '@angular/core';
import { RightSidebarService } from '../../services/rightsidebar.service';
import { WINDOW } from "../../services/window.service";
import { SigninComponent } from '../../authentication/signin/signin.component';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { NewAuditService } from 'src/app/services/new-audit.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { IncidentService } from 'src/app/services/incident.service';
import { AmplitudeService } from 'src/app/shared/services/amplitude.service';
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from 'src/app/services/language.service';
import { filter, take } from 'rxjs/operators';
import { FcmMessagingService } from 'src/app/services/fcm-messaging-service.service';
import { Subscription } from 'rxjs';
import { QrScanDialogComponent } from 'src/app/near-miss/questionnaire/qr-scan-dialog/qr-scan-dialog.component';

const document: any = window.document;

@Component({

  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  supportLanguages = [];
  isNavbarShow: boolean;
  userName: string;
  isOpenApp: any;
  isAppClosed: boolean = false;
  deviceInfo: any;
  showMobileAppOption: boolean = false;
  isIncident: boolean = false;
  rtCode: string;
  selectedlang;
  enableMlFlag: boolean;
  isgp_flag: any;
  villageDetails = [];
  selectedVillage: any;
  isAudits: boolean = false;
  isNearMiss: boolean = false;
  notificationCount: number;
  showNotification: boolean = false;
  title: string;
  message: string;
  pdfurl: string;
  count: number = 0;
  notidata: any = [];
  notiflag: boolean = false;
  filename: any;
  unSubscribe$ = new Subscription();
  constructor(@Inject(DOCUMENT) private document: Document, @Inject(WINDOW) private window: Window,
    @Inject(Renderer2) private renderer: Renderer2, @Inject(ElementRef) public elementRef: ElementRef,
    private dataService: RightSidebarService,
    public loginPage: SigninComponent, public dialog: MatDialog, private userService: UserService,
    private router: Router, private user: UserService, private newAuditServie: NewAuditService, private deviceService: DeviceDetectorService,
    private incidentservice: IncidentService,
    private amplitudeService: AmplitudeService,
    private translateService: TranslateService,
    private languageService: LanguageService,
    private fcmservice: FcmMessagingService
  ) {
    this.unSubscribe$.add(
      router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        this.isAudits = event.url.includes('audits') ? true : false;
        this.isNearMiss = event.url.includes('near-miss') ? true : false;
      })
    );
    this.amplitudeService.setUpAmplitudeOptions();
    this.translateService.setDefaultLang('en');
    this.selectedlang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
    this.translateService.use(this.selectedlang);
    //device: iPad, device: iOS, device: Android, os: Android
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isOpenApp = localStorage.getItem('openAppClicked');

    if (window.innerWidth < 769) {
      if (!isOpenApp && (this.deviceInfo.os === 'Android' || this.deviceInfo.os === 'iOS' || (this.deviceInfo.os === 'iOS' && this.deviceInfo.device === 'iPad') && window.innerWidth < 769)) {
        this.showMobileAppOption = true;
      } else if (!isOpenApp && (this.deviceInfo.device === 'iPad' && this.deviceInfo.os === 'Mac' && window.innerWidth < 769)) {
        this.showMobileAppOption = true;
      } else {
        this.showMobileAppOption = false;
      }
    } else {
      this.showMobileAppOption = false;
    }
  }

  notificationChecks() {
    // Defer notification setup to avoid blocking page render
    setTimeout(() => {
      this.unSubscribe$.add(
        this.fcmservice.getNotificationFlag().subscribe((res: boolean) => {
          this.notiflag = res;
          let flaggranted = false;
          if (this.notiflag) {
            this.getNotificationCount();
            if (Notification.permission === 'granted') {
              console.log('Notification permission granted');
              flaggranted = true;
            } else {
              console.log('Notification permission not granted');
              flaggranted = false;
            }


            this.unSubscribe$.add(
              this.fcmservice.requestPermission().subscribe(() => {
                if (Notification.permission === 'granted') {
                  console.log('Notification permission granted');
                  this.getToken();
                  if (!flaggranted) {
                    this.saveNotificationSettings();
                  }
                }
              })
            );
            
            this.unSubscribe$.add(
              this.fcmservice.receiveMessage().subscribe((message) => {
                console.log(message);
                this.notidata.push(message);
                this.showNotification = true;
                this.title = message.notification.title;
                this.message = message.notification.body;
                this.pdfurl = message.data?.pdfurl;
                this.filename=message.data?.filename;
                this.count = this.count + 1;
                this.getNotificationCount();
                setTimeout(() => {
                  this.showNotification = false;
                  this.notidata = [];
                  this.count=0;
                  this.pdfurl="";
                }, 20000)
              })
            );
            
            this.unSubscribe$.add(
              this.fcmservice.getCountreset().subscribe((res: number) => {
                this.notificationCount = res;
              })
            );
          }
        })
      );
    }, 500); // Defer by 500ms to let page render first
  }

  saveNotificationSettings() {
    const user = JSON.parse(localStorage.getItem('user'));
    const request = {
      guid: user.guid,
      uid: user.id,
      flag_audit_completed: 1,
      flag_audit_approval: 1,
      flag_action_assigned: 1,
      flag_action_assigned_overdue: 1,
      flag_action_completed: 1,
      flag_action_approval: 1,
      flag_schedule_reminder: 1,
      flag_schedule_start: 1,
      flag_schedule_due: 1,
      flag_schedule_missed: 1,
      updated_by_device_id: "GA_WEBAPP",
      updated_by_device_model: "GA_WEBAPP"
    }
    this.fcmservice.updateNotificationSettings(request).subscribe(_data => {
      console.log("Notification settings saved");
    })
  }

  closeNoti() {
    this.showNotification = false;
    this.count=0;
    this.notidata=[];
  }
  getToken(): void {
    this.unSubscribe$.add(
      this.fcmservice.getToken().subscribe((token) => {
        console.log('FCM Token: ', token);
        if (token) {
          this.saveToken(token);
        }
      })
    );
  }
  saveToken(token) {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.token) {
      const tokenobj = {
        device_fcm_token: token,
        token: user.token
      }
      this.fcmservice.updateFcmToken(tokenobj).subscribe(_data => {
        console.log("token saved");
      })
    }
  }

  navigateHistory() {
    this.showNotification = false;
    this.router.navigate(["/notification/notihistory"]);
  }


  gotoNotiHist() {
    const user = JSON.parse(localStorage.getItem('user'));
    const userObj: any = {
      guid: user.guid,
      uid: user.id,
      updated_By: 'webapp'
    }
    this.fcmservice.updateBellicon(userObj).subscribe(_data => {
      this.notificationCount = 0;
      this.router.navigate(["./notification/notihistory"]);
    })
    // if ('Notification' in window) {
      // Check if notification permission is granted
    //   if (Notification.permission === 'granted') {
       

    //   } else if (Notification.permission === 'denied') {
    //     console.log("Push notifications are disabled by the user");

    //   } else {
    //     console.log("Push notification permission has not been asked yet");
    //   }
    // } else {
    //   const user = JSON.parse(localStorage.getItem('user'));
    //     const userObj: any = {
    //       guid: user.guid,
    //       uid: user.id,
    //       updated_By: 'webapp'
    //     }
    //     this.fcmservice.updateBellicon(userObj).subscribe(_data => {
    //       this.notificationCount = 0;
    //       this.router.navigate(["./notification/notihistory"]);
    //     })
    //   console.log("Browser does not support notifications");
    // }
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    const offset = this.window.pageYOffset || this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;
    if (offset > 50) {
      this.isNavbarShow = true;
    } else {
      this.isNavbarShow = false;
    }
  }

  getNotificationCount() {
    const user = JSON.parse(localStorage.getItem('user'));
    const userObj: any = {
      guid: user?.guid,
      uid: user?.id
    }
    this.fcmservice.getNotiCount(userObj).subscribe(data => {
      this.notificationCount = data[0];
    })
  }
  navigateNoti() {
    localStorage.setItem("navigatetoschedule", "false");
    this.notificationCount = 0;
    this.showNotification = false;

    if (this.notidata[this.notidata.length - 1]?.data?.redirect_page==""){
      this.router.navigate(["/notification/notihistory"]);
    }

    if (this.notidata[this.notidata.length - 1]?.data?.url) {
      window.open(this.notidata[this.notidata.length - 1]?.data?.url, "_blank");
    } else if (this.notidata[this.notidata.length - 1]?.data.scheduleId
    ) {
      localStorage.setItem("navigatetoschedule", "true");
      localStorage.setItem("schstatus", this.notidata[this.notidata.length - 1]?.data?.schedulestatus);
      this.router.navigate(["./audits"]);
    }else if (this.notidata[this.notidata.length - 1]?.data?.audit_id) {
      this.router.navigate(["./audits"], { queryParams: { audit_id: this.notidata[this.notidata.length - 1]?.data?.audit_id } });
    }
    else {
      this.router.navigate(["./audits"]);
    }
  }
  getLanguages() {
    this.unSubscribe$.add(
      this.languageService.getLanguagues().subscribe(
        (data) => {

          if (data) {
            this.supportLanguages = data;
            // this.selectedlang = JSON.parse(localStorage.getItem('lang'));
            if (this.selectedlang == "" || this.selectedlang == null) {
              this.selectedlang = this.supportLanguages[0].lang_code;
            }

            this.translateService.use(this.selectedlang);
          }
        }
      )
    );
  }
  getMlFlag() {
    this.unSubscribe$.add(
      this.userService.getMlFlage().subscribe((res) => {
        this.enableMlFlag = res[0]
      })
    );
  }
  ngOnInit() {
    // Set initial route state
    const currentUrl = this.router.url;
    this.isNearMiss = currentUrl.includes('near-miss');    
    this.getLanguages();
    if (localStorage.getItem("isIncidentEnabled") == "1") {
      this.incidentservice.getAdminDetails().subscribe(res => {
        this.rtCode = res[0]
        localStorage.setItem('rtcode', this.rtCode.toString())
      })
    }
    //this.isValid();    
    this.isOpenApp = localStorage.getItem('openAppClicked');
    // // console.log('openAppClicked', this.isOpenApp);
    this.setStartupStyles();

    //subscribe to get local storage open app value
    this.unSubscribe$.add(
      this.newAuditServie.appOpenObs.subscribe(res => {
        // // console.log('this.newAuditServie.appOpenObs', res);
        this.isOpenApp = res;
        if (this.isOpenApp) {
          this.showMobileAppOption = false;
        }
      })
    );

    this.unSubscribe$.add(
      this.newAuditServie.appClosedObs.subscribe(res => {
        if (res) {
          // console.log('isAppClosed', res);
          this.isAppClosed = res;
          if (this.isAppClosed) {
            this.showMobileAppOption = false;
          }
        }
      })
    );

    if (this.isValid()) {
      this.unSubscribe$.add(
        this.user.currentUser.subscribe(res => {
          if (res) {
            this.userName = res.fullname;
          }
        })
      );
    }

    const retrievedObject = localStorage.getItem("password_policy");
    const data = JSON.parse(retrievedObject);

    if (data?.password_policy) {
      const date = new Date(data.password_modified);
      date.setMonth(date.getMonth() + data.expiry_months);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      const curdate = new Date();
      curdate.setHours(0);
      curdate.setMinutes(0);
      curdate.setSeconds(0);
      if (date < curdate) {
        this.changePasswordDialog();
      }

    }
    this.isgp_flag = localStorage.getItem('gp_flag') == 'true' ? true : false;
    const loggedInUser = JSON.parse(localStorage.getItem('user'));
    if (this.isgp_flag) {
      const villages = JSON.parse(localStorage.getItem('villageDetails'));
      if (!villages) {
        this.getVillageDetails(loggedInUser)
      } else {
        this.villageDetails = villages;
        const selected = JSON.parse(localStorage.getItem('selected_village'));
        const defaultVillage = this.villageDetails?.find(village => village.uid == selected?.uid)
        if (defaultVillage) {
          this.selectedVillage = defaultVillage;
        }
      }
    }
    
    // If user is already logged in, initialize immediately
    // Otherwise, wait for device details from login flow
    if (loggedInUser?.token) {
      // User already logged in - initialize immediately
      this.getMlFlag();
      this.notificationChecks();
    } else {
      // Fresh login - wait for device details
      this.checkDeviceDetailsAndCheckMlflag();
    }

  }

  checkDeviceDetailsAndCheckMlflag() {
    this.unSubscribe$.add(
      this.userService.hasDeviceDetails.pipe(
        filter(res => res === true),
        take(1)
      ).subscribe(res => {
        this.getMlFlag();
        this.notificationChecks();
      })
    );
  }


  getVillageDetails(loggedInUser) {
    this.userService.getVillageDetails(loggedInUser.guid, loggedInUser.id).subscribe((res: any) => {
      localStorage.setItem('villageDetails', JSON.stringify(res));
      this.villageDetails = res;
      const defaultVillage = this.villageDetails?.find(village => village.default_user)
      if (defaultVillage) {
        this.selectedVillage = defaultVillage;
        this.onVillageChange();
      }
    }, (_error) => {

    })
  }

  onVillageChange() {
    this.userService.getVillageChangeAuthToken(this.selectedVillage).subscribe(res => {
      const user = JSON.parse(localStorage.getItem('user'));
      user.token = res;
      user.guid = this.selectedVillage.guid
      user.id = this.selectedVillage.uid
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('selected_village', JSON.stringify(this.selectedVillage));
      location.reload();
    })
  }


  /**
    * Language Selection Change method
    * here updating language code
    */
  onselectLanguage(event) {
    const lang = event?.value.toString();
    this.selectedlang = lang;
    this.translateService.use(lang);
    localStorage.setItem('lang', lang);
    const currentUrl = localStorage.getItem('CURRENT_URL');
    if (this.router.url.includes('createautologin')) {
      this.router.navigate(['/' + currentUrl])
    } else {
      this.router
        .navigateByUrl('/authentication/signin', { skipLocationChange: false })
        .then(() => this.router.navigate(['/' + currentUrl]));
    }
  }

  isValid() {
    this.loginPage.checkIfUserLoggedIn();
    return true
  }

  setStartupStyles() {
    //set theme on startup
    if (localStorage.getItem("theme")) {
      this.renderer.removeClass(this.document.body, 'dark');
      this.renderer.removeClass(this.document.body, 'light');
      this.renderer.addClass(this.document.body, localStorage.getItem("theme"));
    } else {
      this.renderer.addClass(this.document.body, 'light');
    }

    // set light sidebar menu on startup
    if (localStorage.getItem("menu_option")) {
      this.renderer.addClass(this.document.body, localStorage.getItem("menu_option"));
    }
    else {
      this.renderer.addClass(this.document.body, 'menu_dark');
      // console.log('menu_dark')
    }

    // set logo color on startup
    if (localStorage.getItem("choose_logoheader")) {
      this.renderer.addClass(this.document.body, localStorage.getItem("choose_logoheader"));
    } else {
      this.renderer.addClass(this.document.body, 'logo-white');
    }
  }

  callFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }

  mobileMenuSidebarOpen(event: any, className: string) {
    const hasClass = event.target.classList.contains(className);
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains("side-closed");
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }

  }
  public toggleRightSidebar(): void {
    this.dataService.currentStatus.pipe(take(1)).subscribe(status => {
      this.dataService.changeMsg(!status);
    });
  }

  logout() {
    // const devId = localStorage.getItem('currentDeviceId');
    // const userDetails = JSON.parse(localStorage.getItem('user'))
    this.fcmservice.deleteToken().subscribe(_d => {

    });
    const issso = localStorage.getItem("issso");

    if (issso) {
      this.ssoLogOut();
    } else {
      this.userService.signOutOfApp();
    }


    // this.userService.signOutDevice(userDetails?.id, [devId]).subscribe(res => {
    //   try {
    //     let issso = localStorage.getItem("issso");

    //     if (issso) {
    //       debugger
    //       this.ssoLogOut();
    //     } else {
    //       this.userService.signOutOfApp();
    //     }
    //   } catch (exception) {
    //   }
    //   // this.userService.signOutOfApp();
    //   // this.router.navigate(['/authentication/signin']);
    // });

  }

  async ssoLogOut() {
    // const val = localStorage.getItem("identifier");
    // let ssoLogoutEndpoint = `https://goaudits.xecurify.com/moas/broker/login/jwt/logout/272506?client_id=t75gRPdKbd6cG5s8&redirect_uri=https://app.goaudits.com/`;
    const ssoLogoutEndpoint = `https://goaudits.xecurify.com/moas/broker/login/jwt/logout/272506?client_id=t75gRPdKbd6cG5s8&redirect_uri=https://app.goaudits.com/`;
    this.userService.signOutOfApp();
    window.open(ssoLogoutEndpoint, "_self");
  }

  changePasswordDialog() {
    this.dialog.open(ChangePasswordDialogExpComponent, {
      height: 'auto',
      width: '500px',
      disableClose: true
    });

  }

  createNearMiss() {
    // Navigate to Raise Near Miss stepper component
    this.router.navigate(['/near-miss/near-misses/raise']);
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  ngOnDestroy() {
    this.unSubscribe$.unsubscribe();
  }
}
